import React, { memo, ReactElement } from 'react'
import { Link } from 'react-router-dom'
import { Translate } from 'react-localize-redux'
import { Button, Result } from 'antd'
import { RouterConfig } from 'core/utils/constants'

const PageNotFound = (): ReactElement => (
  <Result
    status='404'
    title='404'
    subTitle={<Translate id='common.pageMessages.404' />}
    extra={
      <Button size='large' className='default-btn'>
        <Link to={RouterConfig.urlMap.accounts}><Translate id='common.backHome' /></Link>
      </Button>
    }
  />
)

export default memo(PageNotFound)
